import axios from 'axios';
import './Registroest.css'
import {useEffect, useState} from 'react';
import toast, { Toaster } from 'react-hot-toast';
import Chequeado from '../Icons/Check.png';
import Parqueo from '../Icons/1.png';
import Tarjeta from '../Icons/2.png';
import Cash from '../Icons/3.png';
import Deposito from '../Icons/4.png';
import Infos from '../Icons/Info.png';
import Logoicono from '../Componentes/logosvg2';
import { useNavigate } from 'react-router-dom';
import Cropper from 'react-easy-crop';
import  {getCroppedImg} from '../Componentes/cropImage';


function Registroest() {

const notify = () => toast.success('Guardado exitosamente.', {position: 'bottom-right'});
const notifyerr = () => toast.error('No es posible.', {position: 'bottom-right'});
const navigate = useNavigate();

const [errors, setErrors] = useState({
    NombreEstablecimiento: false,/* 
    Departamento: false,
    Municipio: false,
    Zona: false, */
    DireccionEstablecimiento: false,
    DireccionWeb: false,
    TelefonoEstablecimiento: false,
    WhatsappEstablecimiento: false,
    DescripcionEstablecimiento: false,
    LunApertura: false,
    LunCierre: false,
    MarApertura: false,
    MarCierre: false,
    MieApertura: false,
    MieCierre: false,
    JueApertura: false,
    JueCierre: false,
    VieApertura: false,
    VieCierre: false,
    SabApertura: false,
    SabCierre: false,
    DomApertura: false,
    DomCierre: false,
    NombreDueno: false,
    DPIDueno: false
});

    //CONSTANTES
const [bista, setBista] = useState(false);

const Visibl = () => {
    setBista(!bista);
}    

//Checkboxes abren mas opciones
const [checkboxes, setCheckboxes] = useState({
    ctienefut5: false,
    ctienefut7: false,
    ctienefut11: false,
    dialunes: false,
    diamartes: false,
    diamiercoles: false,
    diajueves: false,
    diaviernes: false,
    diasabado: false,
    diadomingo: false,
    tieneparqueo: false,
    efectivo: false,
    transferencia: false,
    tarjeta: false,
    });

const handleCheckboxChange = (e) => {
    const { className, checked} = e.target;
    setCheckboxes((prev) => ({
        ...prev,
        [className]: checked
}));

switch (className) {
    case 'ctienefut5':
        setcanchascinco(0);
        setValoresCinco([]);
        break;
    case 'ctienefut7':
        setcanchassiete(0);
        setValoresSiete([]);
        setRelaciones([]);
        break;
    case 'ctienefut11':
        setcanchasonce(0);
        setValoresOnce([]);
        setRelaciones([]);
        break;
    case 'dialunes':
        if (checkboxes.dialunes === false) {
            setEstable({...estable, ['LunApertura']: null, ['LunCierre']: null});
        } else {
            setEstable({...estable, ['LunApertura']: '', ['LunCierre']: ''});
        }
        break;
    case 'diamartes':
        if (checkboxes.diamartes === false) {
            setEstable({...estable, ['MarApertura']: null, ['MarCierre']: null});
        } else {
            setEstable({...estable, ['MarApertura']: '', ['MarCierre']: ''});
        }
        break;
    case 'diamiercoles':
        if (checkboxes.diamiercoles === false) {
            setEstable({...estable, ['MieApertura']: null, ['MieCierre']: null});
        } else {
            setEstable({...estable, ['MieApertura']: '', ['MieCierre']: ''});
        }
        break;
    case 'diajueves':
        if (checkboxes.diajueves === false) {
            setEstable({...estable, ['JueApertura']: null, ['JueCierre']: null});
        } else {
            setEstable({...estable, ['JueApertura']: '', ['JueCierre']: ''});
        }
        break;
    case 'diaviernes':
        if (checkboxes.diaviernes === false) {
            setEstable({...estable, ['VieApertura']: null, ['VieCierre']: null});
        } else {
            setEstable({...estable, ['VieApertura']: '', ['VieCierre']: ''});
        }
        break;
    case 'diasabado':
        if (checkboxes.diasabado === false) {
            setEstable({...estable, ['SabApertura']: null, ['SabCierre']: null});
        } else {
            setEstable({...estable, ['SabApertura']: '', ['SabCierre']: ''});
        }
        break;
    case 'diadomingo':
        if (checkboxes.diadomingo === false) {
            setEstable({...estable, ['DomApertura']: null, ['DomCierre']: null});
        } else {
            setEstable({...estable, ['DomApertura']: '', ['DomCierre']: ''});
        }
        break;
    case 'tieneparqueo':
        if (checkboxes.tieneparqueo === false) {
            setEstable({...estable, ['Tparqueo']: 'Si'});
        } else {
            setEstable({...estable, ['Tparqueo']: 'No'});
        }
        break;
    case 'efectivo':
        if (checkboxes.efectivo === false) {
            setEstable({...estable, ['efectivo']: 'Si'});
        } else {
            setEstable({...estable, ['efectivo']: 'No'});
        }
        break;
    case 'transferencia':
        if (checkboxes.transferencia === false) {
            setEstable({...estable, ['transferencia']: 'Si'});
        } else {
            setEstable({...estable, ['transferencia']: 'No'});
        }
        break;
    case 'tarjeta':
        if (checkboxes.tarjeta === false) {
            setEstable({...estable, ['tarjeta']: 'Si'});
        } else {
            setEstable({...estable, ['tarjeta']: 'No'});
        }
        break;
    default:
        break;
}
};

const handleaffiliiate = (opt) =>{
    const id = opt
    setEstable((prev) => ({...prev, ['Afiliacion']: id}));
}

//INFO Establecimiento
const [estable, setEstable] = useState({
    NombreEstablecimiento:'',
    DireccionEstablecimiento:'',
    DireccionWeb: '',
    TelefonoEstablecimiento:'',
    WhatsappEstablecimiento:'',
    DescripcionEstablecimiento:'',
    LunApertura: '',
    LunCierre: '',
    MarApertura: '',
    MarCierre: '',
    MieApertura: '',
    MieCierre: '',
    JueApertura: '',
    JueCierre: '',
    VieApertura: '',
    VieCierre: '',
    SabApertura: '',
    SabCierre: '',
    DomApertura: '',
    DomCierre: '',
    NombreDueno:'',
    DPIDueno: '',
    DepositoFut5:'null',
    PrecioFut5: 'null',
    PrecioFut7: 'null',
    DepositoFut7:'null',
    Tparqueo: 'No',
    efectivo: 'No', 
    tarjeta: 'No', 
    transferencia: 'No',
    CorreoIngreso: '',
    ContrasenaIngreso: '',
    Afiliacion: ''
});
const Registrar = (e) =>{
    e.persist();
    setEstable({...estable, [e.target.name]: e.target.value});
    if (e.target.value.trim() !== '') {
        setErrors({...errors, [e.target.name]: false});
    }
};

const [classExt, setClassExt] = useState('');
const RegistrarWeb = (e) =>{
    const soloMinusculas = e.target.value.replace(/[^a-z]/g, '');
    setEstable({
        ...estable,
        [e.target.name]: soloMinusculas
    });
    const slugc = soloMinusculas;
    if (e.target.value.trim() !== '') {
        setErrors({...errors, [e.target.name]: false});
    }
    else if (e.target.value.trim() === ''){
        setClassExt(null); 
        return};
    axios.post(`${process.env.REACT_APP_HTTPS}/api/estable/chkslug`, {slugc})
    .then((res) => {
        if (res.data.exist === true){
            console.log(res.data.message);
            setClassExt(false);
        }
        else if (res.data.exist === false){
            console.log(res.data.message);
            setClassExt(true);
        }
        else {return}
    })
    .catch()};

//No permitir simbolo negativo
const handleKeyDown = (e) => {if (e.key === '-') { e.preventDefault();}};

//Manejo de Canchas de Futbol 5
const [canchascinco, setcanchascinco] = useState(0); // Almacenar cantidad de FUT 5
const [ValoresCinco, setValoresCinco] = useState([]); // Almacenar los valores de Nombre, Descripción y Precio
const handleInputCinco = (e) => {
    const newCanchas = Number(e.target.value);
    setcanchascinco(newCanchas); // Actualiza el estado con el número ingresado
    setValoresCinco((prevValues) => {
        // Si el nuevo número es mayor, agregamos nuevos elementos vacíos al final del arreglo
        if (newCanchas > prevValues.length) {
          const newValues = [...prevValues];
          for (let i = prevValues.length; i < newCanchas; i++) {
            newValues.push({ descripcion: '', precio: '', deposito: ''});
          }
          return newValues;
        }
        // Si el nuevo número es menor, eliminamos los últimos elementos
        else if (newCanchas < prevValues.length) {
            
          return prevValues.slice(0, newCanchas);
        }
        return prevValues;
      });
};
// Maneja los cambios en los inputs de Descripción y Precio
const handleDataCinco = (index, field, value) => {
    const newValues5 = [...ValoresCinco];
    newValues5[index][field] = value; // Actualiza la descripción o el precio del input correspondiente
    setValoresCinco(newValues5);
};
// Función que captura los datos y los imprime

        //Manejo de datos de Futbol 7
const [canchassiete, setcanchassiete] = useState(0); // Almacenar cantidad de FUT 5
const [ValoresSiete, setValoresSiete] = useState([]); // Almacenar los valores de Nombre, Descripción y Precio
const handleInputSiete = (e) => {
    const newCanchas = Number(e.target.value);

    setcanchassiete(newCanchas); // Actualiza el estado con el número ingresado
    setValoresSiete((prevValues) => {
        // Si el nuevo número es mayor, agregamos nuevos elementos vacíos al final del arreglo
        if (newCanchas > prevValues.length) {
          const newValues = [...prevValues];
          for (let i = prevValues.length; i < newCanchas; i++) {
            newValues.push({ descripcion: '', precio: '', deposito: ''});
          }
          return newValues;
        }
        // Si el nuevo número es menor, eliminamos los últimos elementos
        else if (newCanchas < prevValues.length) {
            return prevValues.slice(0, newCanchas);
        }
        return prevValues;
      });
      setCheckedRows([]);
      setRelaciones([]);
};
// Maneja los cambios en los inputs de Descripción y Precio
const handleDataSiete = (index, field, value) => {
    const newValues7 = [...ValoresSiete];
    newValues7[index][field] = value; // Actualiza la descripción o el precio del input correspondiente
    setValoresSiete(newValues7);
};

        //Manejo de datos de Futbol 11
        const [canchasonce, setcanchasonce] = useState(0); // Almacenar cantidad de FUT 5
        const [ValoresOnce, setValoresOnce] = useState([]); // Almacenar los valores de Nombre, Descripción y Precio
        const handleInputOnce = (e) => {
            const newCanchas = Number(e.target.value);
        
            setcanchasonce(newCanchas); // Actualiza el estado con el número ingresado
            setValoresOnce((prevValues) => {
                // Si el nuevo número es mayor, agregamos nuevos elementos vacíos al final del arreglo
                if (newCanchas > prevValues.length) {
                  const newValues = [...prevValues];
                  for (let i = prevValues.length; i < newCanchas; i++) {
                    newValues.push({ descripcion: '', precio: '', deposito: ''});
                  }
                  return newValues;
                }
                // Si el nuevo número es menor, eliminamos los últimos elementos
                else if (newCanchas < prevValues.length) {
                    return prevValues.slice(0, newCanchas);
                }
                return prevValues;
              });
              setCheckedRows([]);
              setRelaciones([]);
        };
        // Maneja los cambios en los inputs de Descripción y Precio
        const handleDataOnce = (index, field, value) => {
            const newValues11 = [...ValoresOnce];
            newValues11[index][field] = value; // Actualiza la descripción o el precio del input correspondiente
            setValoresOnce(newValues11);
        };




// Función que captura los datos y los imprime
const handleSubmit2 = async() => {
    // Validar campos vacíos
   let hasErrors = false;
    let newErrors = {...errors};
    Object.keys(estable).forEach((key) => {
        if (String(estable[key]).trim() === '') {
            newErrors[key] = true;
            hasErrors = true;
        }
    });
    setErrors(newErrors);
    if (hasErrors) {
        console.log(hasErrors, newErrors, estable)
        toast.error('Por favor, completa todos los campos.');
        return;
    } else {
        console.log('no errors', tycch)
        if (tycch === false){
            toast.error('Acepte los Términos y Condiciones', {position:'bottom-center'})
            return;
        }
    }
    
    // Si todos los campos están llenos, envía los datos
    const resultadoFUT11 = ValoresOnce.map((item, index) => ({
        Nombre: `Cancha ${index + 1}`,
        Descripcion: item.descripcion,
        Precio: item.precio,
        Deposito: item.deposito
    }));

    const resultadoFUT7 = ValoresSiete.map((item, index) => ({
        Nombre: `Cancha ${index + 1}`,
        Descripcion: item.descripcion,
        Precio: item.precio,
        Deposito: item.deposito
    }));
    const resultadoFUT5 = ValoresCinco.map((item, index) => ({
        Nombre: `Cancha ${index + 1}`,
        Descripcion: item.descripcion,
        Precio: item.precio,
        Deposito: item.deposito
    }));

    const formData = new FormData();

    for (const tipo in imgcan) {
        if (tipo === 'perfil') {
        const imageSrc = imgcan[tipo][0];
        const cropData = croppedAreaPixels?.[tipo]?.[0];    
        const croppedImageBlob = await getCroppedImg(imageSrc, cropData, 1600, 1000, 1);
        const imageName = `${tipo}_${0}.webp`;
        formData.append('images', croppedImageBlob, imageName);

        // También puedes incluir metadata si lo deseas
        formData.append('metadatas', JSON.stringify({ tipo: tipo, index: 0 }));
        } else {
            for (const index in imgcan[tipo]) {
                console.log('Corrio con tipo' , tipo, index);
                
            const imageSrc = imgcan[tipo][index];
            const cropData = croppedAreaPixels?.[tipo]?.[index];

            if (!imageSrc || !cropData) continue; // Saltar si faltan datos

            const croppedImageBlob = await getCroppedImg(imageSrc, cropData, 400, 400, 0.8);

            // Crear un nombre único por si backend lo necesita
            const imageName = `${tipo}_${index}.webp`;
            formData.append('images', croppedImageBlob, imageName);

            // También puedes incluir metadata si lo deseas
            formData.append('metadatas', JSON.stringify({ tipo: tipo, index: index }));
            }
        };
    }
    formData.append('estable', JSON.stringify(estable));
    formData.append('resultadoFUT5', JSON.stringify(resultadoFUT5));
    formData.append('resultadoFUT7', JSON.stringify(resultadoFUT7));
    formData.append('resultadoFUT11', JSON.stringify(resultadoFUT11));
    formData.append('relaciones', JSON.stringify(relaciones));

  try {
    await axios.post(`${process.env.REACT_APP_HTTPS}/api/establecimiento/saves`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
        .then(response => {
            console.log('Datos guardados exitosamente:', response.data);
            notify();
            setFinal(true);
        })
        .catch((error) => {
            console.error('Error al guardar los datos:', error);
            if (error.response.data.status === 'CorreoInv'){toast.error('Correo invalido', {position:'bottom-right'})}
            notifyerr();
        });
  } catch (err) {
    console.error('Error al enviar imágenes recortadas:', err);
  }
};

const [tycch, setTycch] = useState(false)
const tycmanage = () => {
    setTycch(!tycch);
}
const [final, setFinal] = useState(false);
const registrados = () => {
    navigate('/');
    setFinal(false);
}

        //CREAR CHECKBOXES EN CICLO FUTBOL 7
const [checkedRows, setCheckedRows] = useState([]); // Estado para almacenar los checkboxes activados
// Función para manejar el cambio de los checkboxes
const handleCheckboxChange2 = (index,checked) => {
    console.log(index, checked);
    
    switch (checked) {        
        case true:
            const updatedCheckedRows = [...checkedRows];
            updatedCheckedRows[index] = !updatedCheckedRows[index];
            setCheckedRows(updatedCheckedRows);
        break;
        case false:
            const updatedCheckedRows2 = [...checkedRows];
            updatedCheckedRows2[index] = !updatedCheckedRows2[index];
            setCheckedRows(updatedCheckedRows2);
            setRelaciones((prev) => {
                if (!checked) {
                        return prev.filter(
                            (item) => item.Fut7 !== 'Cancha '+Number(index+1)
                            );
                    } 
                });
        break;
        default:
            break;
    }
};

const [checkedRows2, setCheckedRows2] = useState([]);
const handleCheckboxChange3 = (index,checked) => {
    console.log(index, checked);
    switch (checked) {
        case true:
            const updatedCheckedRows = [...checkedRows2];
            updatedCheckedRows[index] = !updatedCheckedRows[index];
            setCheckedRows2(updatedCheckedRows);
        break;
        case false:
            const updatedCheckedRows2 = [...checkedRows2];
            updatedCheckedRows2[index] = !updatedCheckedRows2[index];
            setCheckedRows2(updatedCheckedRows2);
            setRelaciones((prev) => {
                if (!checked) {
                        return prev.filter(
                            (item) => item.Fut11 !== 'Cancha '+Number(index+1)
                            );
                    } 
                });
        break;
        default:
            break;
    }
};

//Relaciones entre FUT 7 y FUT 5
const [relaciones, setRelaciones] = useState([]);
const handleRelaciones = (fut7, fut5, fut11, checked) => {
const nuevaRelacion = {Fut5: 'Cancha '+fut5, Fut7: 'Cancha '+ fut7,  Fut11: 'Cancha '+ fut11 };
    setRelaciones((prev) => {
    if (checked) {
        // Si está marcado, agregamos el objeto con Fut7 y Fut5 al array
        return [...prev, nuevaRelacion];
    } 
    else if (!checked) {
        if (fut11 === 'v'){
        return prev.filter(
            (item) => item.Fut7 !== 'Cancha '+fut7 || item.Fut5 !== 'Cancha '+fut5
            );
        } else if (fut7 === 'v') {
            return prev.filter(
                (item) => item.Fut11 !== 'Cancha '+fut11 || item.Fut5 !== 'Cancha '+fut5
                );
        }
        else if (fut5 === 'v'){
            return prev.filter(
                (item) => item.Fut11 !== 'Cancha '+fut11 || item.Fut7 !== 'Cancha '+fut7
                );
        }
    } 
    else {
        // Si no está marcado, removemos el objeto del array filtrando por Fut7 y Fut5
        return prev.filter(
        (item) => item.Fut7 !== 'Cancha '+fut7 || item.Fut5 !== 'Cancha '+fut5 || item.Fut11 !== 'Cancha '+fut11
        );
    }
    });
};

// Crop Image

    const [crop, setCrop] = useState({});
    const [zoom, setZoom] = useState({});
    const [croppedAreaPixels, setCroppedAreaPixels] = useState({});

const updateCrop = (tipo, index, value) => {
setCrop((prev) => ({
...prev,
[tipo]: {
    ...(prev[tipo] || {}),
    [index]: value,
},
}));
};

const updateZoom = (tipo, index, value) => {
  setZoom((prev) => ({
    ...prev,
    [tipo]: {
      ...(prev[tipo] || {}),
      [index]: value,
    },
  }));
};

const updateCroppedAreaPixels = (tipo, index, value) => {
  setCroppedAreaPixels((prev) => ({
    ...prev,
    [tipo]: {
      ...(prev[tipo] || {}),
      [index]: value,
    },
  }));
};

const [imgcan, setImgcan] = useState({});
const handleImgCan = async (e, tipo, index) => {

    const file = e.target.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', () => {
        setImgcan((prev) => ({
            ...prev,
            [tipo]: {
                ...(prev[tipo] || {}),
                [index]: reader.result
            }
        }));
    });
    reader.readAsDataURL(file);
};

    return(
        <>
        <div className='Reggg'>
        <div className='Ltitulo'><div className='Llogotitulo'><Logoicono/></div>
        <p onClick={() => navigate('/')} style={{cursor:'pointer', color: 'white', fontSize: '40px', marginTop:'7px'}}>Chamuscón</p></div>
        {final === true ? (<><div className='fondoreg'></div>
        <div className='msgreg'>
            <div>
                <h2 style={{textAlign:"center"}}>¡Registrado exitosamente!</h2>
                <h2>Muchas gracias por formar parte de Chamuscón. Se pondran en contacto con usted para información adicional requerida en las proximas 24 horas.</h2>
                <p>Para cualquier duda o consulta, no dudes en contactarnos y te responderemos lo antes posible. </p>
                <div className='divfinalizar'><button onClick={registrados} className='btnfinalizar'>Terminar</button></div>
                <p style={{fontSize:'11px', textAlign:'right'}}>chamuscongt@gmail.com | +502 3535 8461</p></div>
        </div></>):(<>
            <div className='Registroest'>
                <p style={{fontWeight: "bold", fontSize:"20px"}}>Ingrese correctamente la informacion de su establecimiento. Esta información sera verificada para ser agregada.</p>
                         {/*INFORMACION DEL ESTABLECIMIENTO*/}
        <div className='regprimeraparte'>
            <h2>Establecimiento</h2>
            <p className='pestablecimiento'>Coloca la información del establecimiento, es decir, informacion que pueden ver los clientes.</p>
            <div className='contenedor1'> 
                <div className='rcol1'>
                    <p>Nombre del establecimiento</p>
                    <input type="text" placeholder="Nombre" maxLength={30} name='NombreEstablecimiento' 
                    onChange={Registrar} style={{ borderColor: errors.NombreEstablecimiento ? 'red' : 'initial' }} required/>

                    <div className='croperdiv'>
                        <h2>Inserte su imagen de portada</h2>
                        <p>Inserte la imagen que sera presentada en el inicio de su perfil.
                            Ajuste la imagen segun le parezca mejor.
                        </p>
                    <input type="file" accept="image/*" onChange={(e) => handleImgCan(e, 'perfil', 0)} />
                        {imgcan['perfil']?.[0] && (
                        <>
                            <div className="croper">
                            <Cropper
                                image={imgcan['perfil']?.[0]}
                                crop={crop['perfil']?.[0] || { x: 0, y: 0 }}
                                zoom={zoom['perfil']?.[0] || 1}
                                aspect={16 / 10}
                                onCropChange={(newCrop) => updateCrop('perfil', 0, newCrop)}
                                onZoomChange={(newZoom) => updateZoom('perfil', 0, newZoom)}
                                onCropComplete={(_, areaPixels) => updateCroppedAreaPixels('perfil', 0, areaPixels)}
                            />
                            </div>
                            <input type="range" min={1} max={3} step={0.1} value={zoom['perfil']?.[0] || 1} onChange={(e) => updateZoom(0, 0, parseFloat(e.target.value))}/>
                        </>
                        )}
                    </div>

                    <p>Extensión web: Coloca un nombre en minusculas, que sera tu extensión en la web.</p>
                    <p>Se vera de la siguiente manera: www.chamuscon.com/canchas/{estable.DireccionWeb}</p>
                    <div className='chksluug'><input type="text" placeholder="Extensión" maxLength={30} name='DireccionWeb' value={estable.DireccionWeb}
                    onChange={RegistrarWeb} style={{ borderColor: errors.NombreEstablecimiento ? 'red' : 'initial' }} required/>
                    {classExt === true ? (<><div className='chkslug-true'/><p style={{marginLeft: '10px'}}> Disponible </p></>
                    ): classExt  === false ? (<><div className='chkslug-false'/><p style={{marginLeft: '10px'}}> No disponible </p></>)
                    :(<></>)}
                    </div>

                    {/*<h3>Dirección del establecimiento</h3>
                    <p>Departamento</p>
                    <input type="text" placeholder="Departamento" maxLength={50} name='Departamento' 
                    onChange={Registrar} style={{ borderColor: errors.DireccionEstablecimiento ? 'red' : 'initial' }} required/>
                    <p>Municipio</p>
                    <input type="text" placeholder="Municipio" maxLength={50} name='Municipio' 
                    onChange={Registrar} style={{ borderColor: errors.DireccionEstablecimiento ? 'red' : 'initial' }} required/>
                    <p>Zona</p>
                    <input type="text" placeholder="Zona" maxLength={50} name='Zona' 
                    onChange={Registrar} style={{ borderColor: errors.DireccionEstablecimiento ? 'red' : 'initial' }} required/>*/}
                    <p>Dirección</p>
                    <input type="text" placeholder="Dirección" maxLength={50} name='DireccionEstablecimiento' 
                    onChange={Registrar} style={{ borderColor: errors.DireccionEstablecimiento ? 'red' : 'initial' }} required/>
                </div>
                <div className='rcol2'>
                    <p>Teléfono para contacto</p>
                    <input type="number" placeholder="Teléfono" maxLength={8} name='TelefonoEstablecimiento' 
                    onChange={Registrar} style={{ borderColor: errors.TelefonoEstablecimiento ? 'red' : 'initial' }} required/>
                    <p>WhatsApp</p>
                    <input type="number" placeholder="Numero" maxLength={8} name='WhatsappEstablecimiento' onChange={Registrar}
                    style={{ borderColor: errors.WhatsappEstablecimiento ? 'red' : 'initial' }} required/>
                    <p>Descripción del establecimiento:</p>
                    <textarea className='inpDescripcion' name='DescripcionEstablecimiento' onChange={Registrar} placeholder='Describa su establecimiento'
                    style={{ borderColor: errors.DescripcionEstablecimiento ? 'red' : 'initial' }} required/>
                </div>
            </div>
                <div className='horarios'><h3> Horarios </h3><p>Por favor colocar las horas en punto: <b>12:00</b></p>
                <table className='thorarios'>    
                    <thead>
                        <th>Dia</th>
                        <th>Apertura</th>
                        <th>Cierre</th>
                    </thead>
                    <tbody>
                    <tr>
                            <td>Lunes<br/><label>Cerrado <input className='dialunes' type='checkbox' checked={checkboxes.dialunes} onClick={handleCheckboxChange}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.dialunes} name='LunApertura' onChange={Registrar} value={estable.LunApertura}
                            style={{ borderColor: errors.LunApertura ? 'red' : 'initial' }} required/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.dialunes} name='LunCierre' onChange={Registrar} value={estable.LunCierre}
                            style={{ borderColor: errors.LunCierre ? 'red' : 'initial' }} required/></label></td>
                            
                        </tr>
                        <tr>
                            <td>Martes<br/><label>Cerrado <input className='diamartes' type='checkbox' checked={checkboxes.diamartes} onClick={handleCheckboxChange}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diamartes} name='MarApertura' onChange={Registrar} value={estable.MarApertura}
                            style={{ borderColor: errors.MarApertura ? 'red' : 'initial' }} required/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diamartes} name='MarCierre' onChange={Registrar} value={estable.MarCierre}
                            style={{ borderColor: errors.MarCierre ? 'red' : 'initial' }} required/></label></td>
                        </tr>
                        <tr>
                            <td>Miércoles<br/><label>Cerrado <input className='diamiercoles' type='checkbox' checked={checkboxes.diamiercoles} onClick={handleCheckboxChange}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diamiercoles} name='MieApertura' onChange={Registrar} value={estable.MieApertura}
                            style={{ borderColor: errors.MieApertura ? 'red' : 'initial' }} required/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diamiercoles} name='MieCierre' onChange={Registrar}value={estable.MieCierre}
                            style={{ borderColor: errors.MieCierre ? 'red' : 'initial' }} required/></label></td>
                        </tr>
                        <tr>
                            <td>Jueves<br/><label>Cerrado <input className='diajueves' type='checkbox' checked={checkboxes.diajueves} onClick={handleCheckboxChange}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diajueves} name='JueApertura' onChange={Registrar} value={estable.JueApertura}
                            style={{ borderColor: errors.JueApertura ? 'red' : 'initial' }} required/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diajueves} name='JueCierre' onChange={Registrar} value={estable.JueCierre}
                            style={{ borderColor: errors.JueCierre ? 'red' : 'initial' }} required/></label></td>
                        </tr>
                        <tr>
                            <td>Viernes<br/><label>Cerrado <input className='diaviernes' type='checkbox' checked={checkboxes.diaviernes} onClick={handleCheckboxChange}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diaviernes} name='VieApertura' onChange={Registrar} value={estable.VieApertura}
                            style={{ borderColor: errors.VieApertura ? 'red' : 'initial' }} required/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diaviernes} name='VieCierre' onChange={Registrar} value={estable.VieCierre}
                            style={{ borderColor: errors.VieCierre ? 'red' : 'initial' }} required/></label></td>
                        </tr>
                        <tr>
                            <td>Sábado<br/><label>Cerrado <input className='diasabado' type='checkbox' checked={checkboxes.diasabado} onClick={handleCheckboxChange}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diasabado} name='SabApertura' onChange={Registrar} value={estable.SabApertura}
                            style={{ borderColor: errors.SabApertura ? 'red' : 'initial' }} required/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diasabado} name='SabCierre' onChange={Registrar} value={estable.SabCierre}
                            style={{ borderColor: errors.SabCierre ? 'red' : 'initial' }} required/></label></td>
                        </tr>
                        <tr>
                            <td>Domingo<br/><label>Cerrado <input className='diadomingo' type='checkbox' checked={checkboxes.diadomingo} onClick={handleCheckboxChange}/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diadomingo} name='DomApertura' onChange={Registrar} value={estable.DomApertura}
                            style={{ borderColor: errors.DomApertura ? 'red' : 'initial' }} required/></label></td>
                            <td><label><input type='time' step={3600} disabled={checkboxes.diadomingo} name='DomCierre' onChange={Registrar} value={estable.DomCierre}
                            style={{ borderColor: errors.DomCierre ? 'red' : 'initial' }} required/></label></td>
                        </tr>
                    </tbody>
                </table></div>
                <div className='parqueo'>
                    <h3>Cuentas con:</h3>
                    <p className='txtparqueo'>Haz clic sobre los extras que posees</p>
                    <div>
                    <label className='custom-checkbox'>
                        <input type='checkbox' className='tieneparqueo' checked={checkboxes.tieneparqueo} onChange={handleCheckboxChange} />
                        <span className='checkbox-image'>
                            <img src={Parqueo} alt='Parqueo' /> {/* Add your image here */}
                        </span>
                        Parqueo
                    </label>
                    <label className='custom-checkbox'>
                        <input type='checkbox' className='efectivo' checked={checkboxes.efectivo} onChange={handleCheckboxChange} />
                        <span className='checkbox-image'>
                            <img src={Cash} alt='Efectivo' /> {/* Add your image here */}
                        </span>
                        Pago efectivo
                    </label>
                    <label className='custom-checkbox'>
                        <input type='checkbox' className='tarjeta' checked={checkboxes.tarjeta} onChange={handleCheckboxChange} />
                        <span className='checkbox-image'>
                            <img src={Tarjeta} alt='Tarjeta' /> {/* Add your image here */}
                        </span>
                        Pago tarjeta
                    </label>
                    <label className='custom-checkbox'>
                        <input type='checkbox' className='transferencia' checked={checkboxes.transferencia} onChange={handleCheckboxChange} />
                        <span className='checkbox-image'>
                            <img src={Deposito} alt='Transferencia' /> {/* Add your image here */}
                        </span>
                        Pago transferencia
                    </label>
                    </div>
                     {/*Add more checkboxes as needed*/} 
                </div>
            <br/>
                        {/*REGISTRO DE CANCHAS*/}
            <div className='canchas'>
            <h3>Ingreso de canchas</h3>
            <p>Ingresa la cantidad de canchas para alquiler que dispone tu establecimiento. Si tienes dudas, no dudes en contactarnos para poder asesorarte.</p>
            <p>Selecciona los tipos de canchas de los que dispones: </p><br/>
                <div className='canchas5'>
                    <label className='ltienefut5'>
                        <p>Fútbol 5 </p><input className='ctienefut5' type='checkbox' checked={checkboxes.ctienefut5} onClick={handleCheckboxChange}/>
                    </label><br/>
                    {checkboxes.ctienefut5 && (
                    <div className='registrofut5'> 
                        ¿Con cuántas canchas de fútbol 5 dispones? <input type='number' className='corto' value={canchascinco} min='0' 
                        onChange={handleInputCinco} onKeyDown={handleKeyDown} />
                        <p>Coloca una pequena descrcipción de la cancha, como el material o tamaño. Además, coloca el precio. Coloca una imagen para ayudar a tus clientes a elegir su cancha.</p>
                        <table className='tprueba2'>
                            <thead>
                                <tr>
                                    <th className='thnum'>No. de cancha</th>
                                    <th className='thdesc'>Descripción</th>
                                    <th className='thprecio'>Precio</th>
                                    <th className='thdeposito'>Depósito</th>
                                    <th className='thimg'>Foto</th>
                                </tr>
                             </thead>
                             <tbody>
                                {[...Array(Number(canchascinco))].map((_, index1) => (
                                    <tr key={index1}>
                                        <td><p> Cancha {index1 + 1} </p></td>
                                        <td><label><input type='text' maxLength={30} className='tdindesc5'
                                        placeholder="Descripción" onChange={(e) => handleDataCinco(index1, 'descripcion', e.target.value)}/></label></td>
                                        <td>
                                            <input type='number' placeholder='Precio' step={0.01} className='precio' onChange={(e) => handleDataCinco(index1, 'precio', e.target.value)} />
                                        </td>
                                        <td>
                                            <input type='number' placeholder='Depósito' step={0.01} className='precio' onChange={(e) => handleDataCinco(index1, 'deposito', e.target.value)}/>
                                        </td>
                                        <td><input type="file" accept="image/*" onChange={(e) => handleImgCan(e, 5, index1)} />
                                            {imgcan[5]?.[index1] && (
                                            <><br/>
                                            <input type="range" min={1} max={3} step={0.1} value={zoom[5]?.[index1] || 1} onChange={(e) => updateZoom(5, index1, parseFloat(e.target.value))}/>
                                                <div className="croperca">
                                                <Cropper
                                                    image={imgcan[5]?.[index1]}
                                                    crop={crop[5]?.[index1] || { x: 0, y: 0 }}
                                                    zoom={zoom[5]?.[index1] || 1}
                                                    aspect={1 / 1}
                                                    onCropChange={(newCrop) => updateCrop(5, index1, newCrop)}
                                                    onZoomChange={(newZoom) => updateZoom(5, index1, newZoom)}
                                                    onCropComplete={(_, areaPixels) => updateCroppedAreaPixels(5, index1, areaPixels)}
                                                    objectFit='cover'
                                                />
                                                </div>
                                            </>
                                            )}
                                        </td>
                                    </tr>                            
                                ))}
                            </tbody>
                        </table>
                    </div>  
                    )}
                </div><br/>
                

                <div className='canchas7'>
                    <label className='ltienefut7'>
                        <p>Fútbol 7 </p><input className='ctienefut7' type='checkbox' checked={checkboxes.ctienefut7} onClick={handleCheckboxChange} />
                    </label><br/>
                    {checkboxes.ctienefut7 && (
                    <div className='registrofut7'>  
                        ¿Con cuántas canchas de fútbol 7 dispones? <input type='number' className='corto' value={canchassiete} min='0' 
                        onChange={handleInputSiete} onKeyDown={handleKeyDown}  />
                        <p>Coloca una pequena descrcipción de la cancha, como el material o tamaño. Además, coloca el precio.</p>
                        <table className='tprueba2'>
                            <thead>
                                <tr>
                                    <th className='thnum'>No. de cancha</th>
                                    <th className='thdesc'>Descripcion</th>
                                    <th className='thprecio'>Precio</th>
                                    <th className='thdeposito'>Depósito</th>
                                    <th className='thenlace'>¿Contiene otras canchas?</th>
                                    <th className='thimg'>Foto</th>
                                </tr>
                             </thead>
                             <tbody>
                                {[...Array(Number(canchassiete))].map((_, index2) => (
                                    <tr key={index2}>
                                        <td><p> Cancha {index2 + 1} </p></td>
                                        <td ><label><input type='text' maxLength={30} className='tdindesc5' 
                                         placeholder="Descripción" onChange={(e) => handleDataSiete(index2, 'descripcion', e.target.value)}/></label></td>
                                         <td>
                                            <input type='number' placeholder='Precio' step={0.01} className='precio' onChange={(e) => handleDataSiete(index2, 'precio', e.target.value)} />
                                        </td>
                                        <td>
                                            <input type='number' placeholder='Depósito' step={0.01} className='precio' onChange={(e) => handleDataSiete(index2, 'deposito', e.target.value)}/>
                                        </td>
                                        <td>
                                            <label>Si <input className='' type='checkbox' checked={checkedRows[index2]} onChange={(e) => handleCheckboxChange2(index2,e.target.checked)} /></label><br/>
                                            {checkedRows[index2] && (
                                                <div className='cbfut7'>
                                                    <p key={index2}>¿Qué canchas de <b>Futbol 5</b> contiene la cancha {index2 + 1} de Futbol 7?</p>
                                                    <div className='cbfut7d'>
                                                    {[...Array(Number(canchascinco))].map((_, index3) => (
                                                        <div>
                                                            <label>
                                                            Cancha {index3 + 1} <input key={index3} type="checkbox" onChange={(e) =>handleRelaciones(Number(index2+1), Number(index3+1), 'v', e.target.checked)}/></label>
                                                        </div>
                                                    ))}
                                                    </div>
                                                </div>
                                            )}
                                        </td>
                                        <td><input type="file" accept="image/*" onChange={(e) => handleImgCan(e, 7, index2)} />
                                            {imgcan[7]?.[index2] && (
                                            <><br/>
                                                <input type="range" min={1} max={3} step={0.1} value={zoom[7]?.[index2] || 1} onChange={(e) => updateZoom(7, index2, parseFloat(e.target.value))}/>
                                                <div className="croperca">
                                                <Cropper
                                                    image={imgcan[7]?.[index2]}
                                                    crop={crop[7]?.[index2] || { x: 0, y: 0 }}
                                                    zoom={zoom[7]?.[index2] || 1}
                                                    aspect={1 / 1}
                                                    onCropChange={(newCrop) => updateCrop(7, index2, newCrop)}
                                                    onZoomChange={(newZoom) => updateZoom(7, index2, newZoom)}
                                                    onCropComplete={(_, areaPixels) => updateCroppedAreaPixels(7, index2, areaPixels)}
                                                    objectFit='cover'
                                                />
                                                </div>
                                            </>
                                            )}
                                        </td>
                                    </tr>                            
                                ))}
                            </tbody>
                        </table>
                    </div>  
                    )}
                </div><br/>

                <div className='canchas11'>
                    <label className='ltienefut11'>
                        <b><p>Fútbol 11 </p></b><input className='ctienefut11' type='checkbox' checked={checkboxes.ctienefut11} onClick={handleCheckboxChange} />
                    </label><br/>
                    {checkboxes.ctienefut11 && (
                    <div className='registrofut7'>  
                        ¿Con cuántas canchas de fútbol 11 dispones? <input type='number' className='corto' value={canchasonce} min='0' 
                        onChange={handleInputOnce} onKeyDown={handleKeyDown}  />
                        <p>Coloca una pequena descrcipción de la cancha, como el material o tamaño. Además, coloca el precio.</p>
                        <table className='tprueba2'>
                            <thead>
                                <tr>
                                    <th className='thnum'>No. de cancha</th>
                                    <th className='thdesc'>Descripcion</th>
                                    <th className='thprecio'>Precio</th>
                                    <th className='thdeposito'>Depósito</th>
                                    <th className='thenlace'>¿Contiene otras canchas?</th>
                                    <th className='thimg'>Foto</th>
                                </tr>
                             </thead>
                             <tbody>
                                {[...Array(Number(canchasonce))].map((_, index2) => (
                                    <tr key={index2}>
                                        <td><p> Cancha {index2 + 1} </p></td>
                                        <td ><label><input type='text' maxLength={30} className='tdindesc5' 
                                         placeholder="Descripción" onChange={(e) => handleDataOnce(index2, 'descripcion', e.target.value)}/></label></td>
                                         <td>
                                            <input type='number' placeholder='Precio' step={0.01} className='precio' onChange={(e) => handleDataOnce(index2, 'precio', e.target.value)} />
                                        </td>
                                        <td>
                                            <input type='number' placeholder='Depósito' step={0.01} className='precio' onChange={(e) => handleDataOnce(index2, 'deposito', e.target.value)}/>
                                        </td>
                                        <td>
                                            <label>Si <input className='' type='checkbox' checked={checkedRows2[index2]} onChange={(e) => handleCheckboxChange3(index2,e.target.checked)} /></label><br/>
                                            {checkedRows2[index2] && (
                                            <div className='cbtodas'>   
                                                <div className='cbfut7'>
                                                    <p key={index2}>¿Qué canchas de <b>Futbol 5</b> contiene la cancha {index2 + 1} de Futbol 11?</p>
                                                    <div className='cbfut7d'>
                                                    {[...Array(Number(canchascinco))].map((_, index3) => (
                                                        <div>
                                                            <label>
                                                            Cancha {index3 + 1} <input key={index3} type="checkbox" onChange={(e) =>handleRelaciones('v', Number(index2+1),Number(index3+1), e.target.checked)}/></label>
                                                        </div>
                                                    ))}
                                                    </div>
                                                </div>
                                                <div className='cbfut7'>
                                                <p key={index2}>¿Qué canchas de <b>Futbol 7</b> contiene la cancha {index2 + 1} de Futbol 11?</p>
                                                <div className='cbfut7d'>
                                                {[...Array(Number(canchassiete))].map((_, index3) => (
                                                    <div>
                                                        <label>
                                                        Cancha {index3 + 1} <input key={index3} type="checkbox" onChange={(e) =>handleRelaciones(Number(index2+1), 'v', Number(index3+1), e.target.checked)}/></label>
                                                    </div>
                                                ))}
                                                </div>
                                            </div>
                                            </div> )}
                                        </td>
                                        <td><input type="file" accept="image/*" onChange={(e) => handleImgCan(e, 11, index2)} />
                                            {imgcan[11]?.[index2] && (
                                            <><br/>
                                                <input type="range" min={1} max={3} step={0.1} value={zoom[11]?.[index2] || 1} onChange={(e) => updateZoom(11, index2, parseFloat(e.target.value))}/>
                                                <div className="croperca">
                                                <Cropper
                                                    image={imgcan[11]?.[index2]}
                                                    crop={crop[11]?.[index2] || { x: 0, y: 0 }}
                                                    zoom={zoom[11]?.[index2] || 1}
                                                    aspect={1 / 1}
                                                    onCropChange={(newCrop) => updateCrop(11, index2, newCrop)}
                                                    onZoomChange={(newZoom) => updateZoom(11, index2, newZoom)}
                                                    onCropComplete={(_, areaPixels) => updateCroppedAreaPixels(11, index2, areaPixels)}
                                                    objectFit='cover'
                                                />
                                                </div>
                                            </>
                                            )}
                                        </td>
                                    </tr>                            
                                ))}
                            </tbody>
                        </table>
                    </div>  
                    )}
                </div>
            </div>
            <button onClick={() => console.log(relaciones) }> Jason </button>
        </div>
                                {/*INFORMACION DEL DUENO*/}
        <div>
            <h2 >Informacion de contacto</h2>
            <div className='contenedor2'>
                <p className='pcontacto'>Coloca la información de la persona propietaria del establecimiento.</p>
                    <p>Nombre y apellido</p>
                    <input type="text" placeholder="Nombre y apellido" maxLength={30} name='NombreDueno' onChange={Registrar}
                    style={{ borderColor: errors.NombreDueno ? 'red' : 'initial' }} required/>
                    <br/>
                    <p>DPI</p>
                    <input type="number" placeholder="DPI" minLength={12} maxLength={13} name='DPIDueno' onChange={Registrar}
                    style={{ borderColor: errors.DPIDueno ? 'red' : 'initial' }} required/>
            </div>
        </div>
        <div>
            <h2>Credenciales de ingreso</h2>
            <p className='pcontacto'>Coloca la informacion que sera util para iniciar sesion.</p>
            <p>Correo electronico: </p>
            <input type="email" placeholder="Correo" maxLength={30} name='CorreoIngreso' onChange={Registrar}
                    style={{ borderColor: errors.CorreoIngreso ? 'red' : 'initial' }} required/>
            <p>Contraseña: </p>
            <input type="password" placeholder="Contrasena" maxLength={30} name='ContrasenaIngreso' onChange={Registrar}
                    style={{ borderColor: errors.ContrasenaIngreso ? 'red' : 'initial' }} required/>        
        </div>
        <div>
            <h2>Opciones de afiliación</h2>
            <p className='pcontacto'>Para formar parte de nuestra plataforma te ofrecemos dos maneras de afiliación:</p>
            <p>Es necesario contar con NIT de persona jurídica para afiliarse, es decir, NIT de la empresa registrada.</p>
            <div className='afiliacion'>
                <div className={estable.Afiliacion === 'Afiliado' ? 'opcpaga-click' : 'opcpaga'} onClick={() => handleaffiliiate('Afiliado')}>
                    <h3 style={{textAlign:'center'}}>Afiliado</h3>
                    <ul style={{listStyle:"none"}}> 
                        <li className='listapremium'><img src={Chequeado} className='iconoreg'/>Presencia en el mapa.</li>
                        <li className='listapremium'><img src={Chequeado} className='iconoreg'/>Acceso a plataforma para el manejo de reservas.</li>
                        <li className='listapremium'><img src={Chequeado} className='iconoreg'/>Recepción de reservas en línea.</li>
                        <li className='listapremium'><img src={Chequeado} className='iconoreg'/>Facilidad para tus clientes de reservar como nunca.</li>
                        <li className='listapremium'><img src={Chequeado} className='iconoreg'/><p>Costo por reserva: Q4 + 4% sobre el depósito <img src={Infos} className='iconoreg' onMouseOver={Visibl} onMouseLeave={Visibl}/>
                        {bista ? (<div className='depcalc'>
                            Por un depósito de:
                            <ul style={{listStyle:"none"}}>
                                <li>Q50.00 recibirán Q44.00</li>
                                <li>Q75.00 recibirán Q68.00</li>
                                <li>Q100.00 recibirán Q92.00</li>
                                <li>Q125.00 recibirán Q116.00</li>
                                <li>Q150.00 recibirán Q140.00</li>
                                <li>Q175.00 recibirán Q164.00</li>
                            </ul>
                        </div>):(<></>)}</p></li>
                    </ul>
                </div>
                <div className={estable.Afiliacion === 'Registrado' ? 'opcfree-click' : 'opcfree'} onClick={() =>handleaffiliiate('Registrado')}>
                <h3 style={{textAlign:'center'}}>Registrado</h3>
                    <ul style={{listStyle:"none"}}> 
                        <li className='listapremium'><img src={Chequeado} className='iconoreg'/>Presencia en el mapa.</li>
                        <li className='listapremium'><img src={Chequeado} className='iconoreg'/>Visualización de información en la plataforma.</li>
                    </ul>
                </div>  
            </div>
        </div>
        <label style={{fontSize:"25px"}}>
            Acepto los <a href='https://drive.google.com/file/d/1oGXW-PifToiQayl4Pu_HLdLJ7Yt7otct/view' target='_blank' rel='noopener noreferrer'>Terminos y Condiciones de Chamuscón Guatemala.</a>
            <input type='checkbox' style={{margin:"20px", width:"20px"}} onChange={tycmanage}/>
        </label><br/>
        <button type='submit' className='registrar' value='Registrar' onClick={handleSubmit2}> Registrar </button>
    </div>
        </>)}
        <Toaster /></div></>
    );
}

export default Registroest;